<app-spinner *ngIf="loaderService.loading$ | async"></app-spinner>
<div class="page-container">
    <router-outlet class="flex-grow-0"></router-outlet>
</div>